export default __webpack_public_path__ + "static/media/collectButton-done.2bf85086.svg";